import React, { useState, useEffect } from 'react';
import {
  SliderContainer,
  SliderTrack,
  SliderProgress,
  SliderThumb,
  SliderInputContainer,
  StackContainer,
} from './SliderInput.styles';
import Typography from 'src/app/atoms/Typography/Typography';

export interface SliderInputProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
  className?: string;
  label?: string;
}

const SliderInput: React.FC<SliderInputProps> = ({
  value,
  onChange,
  min = 0,
  max = 100,
  step = 1,
  disabled = false,
  className,
  label,
}) => {
  const [percentage, setPercentage] = useState(() => {
    const newPercentage = ((value - min) / (max - min)) * 100;
    return newPercentage;
  });

  useEffect(() => {
    const newPercentage = ((value - min) / (max - min)) * 100;
    setPercentage(newPercentage);
  }, [value, min, max]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!disabled) {
      const newValue = Number(e.target.value);
      onChange(newValue);
    }
  };

  return (
    <StackContainer
      direction='column'
      gap='spacing-sm'
      className={className}
      dataCy='slider-container'
    >
      {label && (
        <Typography
          type='paragraph'
          size='sm'
          color='text-secondary'
          dataCy='slider-label'
        >
          {label}
        </Typography>
      )}
      <SliderContainer data-cy='slider-track-container'>
        <SliderTrack data-cy='slider-track'>
          <SliderProgress
            $value={percentage}
            data-cy='slider-progress'
          />
          <SliderThumb
            $value={percentage}
            data-cy='slider-thumb'
          />
        </SliderTrack>
        <SliderInputContainer
          type='range'
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={handleChange}
          disabled={disabled}
          data-cy='slider-input'
        />
      </SliderContainer>
    </StackContainer>
  );
};

export default SliderInput;
